module.exports = __webpack_public_path__ + "img/racks.8cbe876b.jpg";